import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SdsDocIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SdsDocIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        fill="#0F69AF"
        d="M0.3,9.84l3.54-3.54c0.39-0.39,1.02-0.39,1.41,0l3.54,3.54c0.39,0.39,0.39,1.02,0,1.41l-3.54,3.54 c-0.39,0.39-1.02,0.39-1.41,0L0.3,11.26C-0.09,10.87-0.09,10.23,0.3,9.84z"
      />
      <path
        fill="#E61E50"
        d="M6.31,3.83L9.84,0.3c0.39-0.39,1.02-0.39,1.41,0l3.54,3.54c0.39,0.39,0.39,1.02,0,1.41l-3.54,3.54 c-0.39,0.39-1.02,0.39-1.41,0L6.31,5.25C5.92,4.86,5.92,4.22,6.31,3.83z"
      />
      <path
        fill="#F2F2F2"
        d="M6.31,15.85l3.54-3.54c0.39-0.39,1.02-0.39,1.41,0l3.54,3.54c0.39,0.39,0.39,1.02,0,1.41l-3.54,3.54 c-0.39,0.39-1.02,0.39-1.41,0l-3.54-3.54C5.92,16.88,5.92,16.24,6.31,15.85z"
      />
      <path
        fill="#FFC832"
        d="M12.32,9.84l3.54-3.54c0.39-0.39,1.02-0.39,1.41,0l3.54,3.54c0.39,0.39,0.39,1.02,0,1.41l-3.54,3.54 c-0.39,0.39-1.02,0.39-1.41,0l-3.54-3.54C11.93,10.87,11.93,10.23,12.32,9.84z"
      />
    </Icon>
  )
}
export default SdsDocIcon
